export default __webpack_public_path__ + "static/media/betterSmiley.3b153383.svg";